import { diContainer } from '../DIContainer';
export class Settings {
    static get $settings() {
        return diContainer.resolve('settings');
    }
    static get appName() {
        return Settings.$settings.appName;
    }
    static get version() {
        return Settings.$settings.version;
    }
    static get certifiedVersion() {
        return Settings.$settings.certifiedVersion;
    }
    static get env() {
        return Settings.$settings.env;
    }
    static get electron() {
        return Settings.$settings.electron;
    }
    static onUnauthorized(isTenantUnauthorized) {
        Settings.$settings.onUnauthorized(isTenantUnauthorized);
    }
    static onLocaleChange(locale) {
        Settings.$settings.onLocaleChange(locale);
    }
}
export default Settings;
//# sourceMappingURL=Settings.js.map